/* CROSSBAR KITS · v3 interactions (hero, rails, tabs, ticker) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    var slides = [].slice.call(root.querySelectorAll('.cb-slide'));
    var tabs = [].slice.call(root.querySelectorAll('.cb-hero__tab'));
    if (slides.length < 2) return;
    var dur = parseInt(root.getAttribute('data-duration') || '7000', 10);
    root.style.setProperty('--cb-dur', dur + 'ms');
    var i = 0, timer = null, paused = false;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      tabs.forEach(function (t, k) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) { void t.offsetWidth; t.classList.add('is-active'); }
      });
      // lazy image of the next slide
      var nx = slides[(i + 1) % slides.length].querySelector('img[data-src]');
      if (nx) { nx.src = nx.getAttribute('data-src'); nx.removeAttribute('data-src'); }
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (reduce || paused) return;
      timer = setTimeout(function () { go(i + 1); }, dur);
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); schedule(); });
    root.addEventListener('focusin', function () { paused = true; clearTimeout(timer); });
    // swipe
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
    go(0);
  }

  /* ---------- Rails ---------- */
  function initRail(rail) {
    var track = rail.querySelector('.cb-rail__track');
    var prev = rail.querySelector('.cb-rail__btn--prev');
    var next = rail.querySelector('.cb-rail__btn--next');
    if (!track) return;
    function upd() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Tabs (league filter over one product set) ---------- */
  function initTabs(root) {
    var tabs = [].slice.call(root.querySelectorAll('.cb-tab'));
    var items = [].slice.call(root.querySelectorAll('[data-league]'));
    var more = root.querySelector('[data-cb-more]');
    var limit = parseInt(root.getAttribute('data-limit') || '10', 10);
    function show(t) {
      var key = t.getAttribute('data-key');
      tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var n = 0;
      items.forEach(function (el) {
        var ok = key === 'all' || el.getAttribute('data-league') === key || (key === 'other' && el.getAttribute('data-big') !== '1');
        if (ok && n < limit) { el.hidden = false; n++; } else { el.hidden = true; }
      });
      if (more) {
        more.href = t.getAttribute('data-url');
        var lbl = more.querySelector('[data-cb-more-label]');
        if (lbl) lbl.textContent = t.getAttribute('data-label');
      }
      var track = root.querySelector('.cb-rail__track');
      if (track) { track.scrollLeft = 0; track.dispatchEvent(new Event('scroll')); }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    if (tabs[0]) show(tabs[0]);
  }

  /* ---------- Ticker (mobile rotation) ---------- */
  function initTicker(root) {
    var msgs = [].slice.call(root.querySelectorAll('.cb-ticker__msg'));
    if (msgs.length < 2) return;
    var i = 0;
    msgs[0].classList.add('is-on');
    if (reduce) return;
    setInterval(function () {
      if (window.innerWidth >= 1360) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3800);
  }

  function boot() {
    document.querySelectorAll('[data-cb-hero]').forEach(initHero);
    document.querySelectorAll('[data-cb-rail]').forEach(initRail);
    document.querySelectorAll('[data-cb-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-cb-ticker]').forEach(initTicker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* v4 · parallax hero, 3D tilt cards, scroll reveal */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reduce) return;
  function parallax(root) {
    if (!fine || root.dataset.cbPx) return; root.dataset.cbPx = '1';
    var raf = null, tx = 0, ty = 0;
    root.addEventListener('mousemove', function (e) {
      var r = root.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2; ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(function () { root.style.setProperty('--mx', tx.toFixed(3)); root.style.setProperty('--my', ty.toFixed(3)); raf = null; });
    });
    root.addEventListener('mouseleave', function () { root.style.setProperty('--mx', 0); root.style.setProperty('--my', 0); });
  }
  function tilt(card) {
    if (!fine || card.dataset.cbTilt) return; card.dataset.cbTilt = '1';
    var media = card.querySelector('.cb-card__media'); if (!media) return;
    if (!media.querySelector('.cb-card__shine')) { var s = document.createElement('span'); s.className = 'cb-card__shine'; media.appendChild(s); }
    media.addEventListener('mousemove', function (e) {
      var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.classList.add('is-tilting');
      media.style.transform = 'perspective(800px) rotateX(' + ((0.5 - y) * 9).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 11).toFixed(2) + 'deg) translateZ(0)';
      media.style.setProperty('--sx', (x * 100).toFixed(1) + '%'); media.style.setProperty('--sy', (y * 100).toFixed(1) + '%');
    });
    media.addEventListener('mouseleave', function () { card.classList.remove('is-tilting'); media.style.transform = ''; });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function boot() {
    document.querySelectorAll('[data-cb-parallax]').forEach(parallax);
    document.querySelectorAll('.cb-card').forEach(tilt);
    if (io) document.querySelectorAll('.cb-home .cb-sec .cb-head, .cb-home .cb-offer, .cb-home .cb-clubs__grid, .cb-home .cb-leagues, .cb-home .cb-why').forEach(function (el) {
      if (el.classList.contains('cb-reveal') || el.dataset.cbRv) return;
      el.dataset.cbRv = '1';
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('cb-reveal'); io.observe(el);
    });
    setTimeout(function () { document.querySelectorAll('.cb-reveal:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.2) el.classList.add('is-in'); }); }, 1500);
    window.addEventListener('scroll', function () { document.querySelectorAll('.cb-reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('is-in'); }); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  var mq = null; new MutationObserver(function () { if (mq) return; mq = setTimeout(function () { mq = null; document.querySelectorAll('.cb-card:not([data-cb-tilt])').forEach(tilt); }, 300); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Interactivity v5: progress bar, quick-add sizes, card entrance, PDP zoom ===== */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = window.cbI18n || {};
  // progress bar
  if (!reduce && !document.querySelector('.cb-progress')) {
    var bar = document.createElement('div'); bar.className = 'cb-progress'; document.body.appendChild(bar);
    var tk = false;
    window.addEventListener('scroll', function () { if (tk) return; tk = true; requestAnimationFrame(function () {
      var h = document.documentElement.scrollHeight - innerHeight; bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')'; tk = false; }); }, { passive: true });
  }
  // toast
  var toast;
  function showToast(img, name, size) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'cb-qa-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = '<img alt="" src="' + img + '"><div><b>' + (T.added || 'Added to bag') + '</b><small>' + name + ' · ' + size + '</small></div><a href="/cart">' + (T.view || 'View bag') + '</a>';
    toast.classList.remove('is-open'); void toast.offsetWidth; toast.classList.add('is-open');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 4200);
  }
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = c.item_count || 0, link = document.querySelector('.ld-header__cart'), cnt = document.querySelector('.ld-header__cart-count');
      if (link && !cnt) { cnt = document.createElement('span'); cnt.className = 'ld-header__cart-count'; link.appendChild(cnt); }
      if (cnt) { cnt.textContent = n; cnt.classList.add('is-pulse'); setTimeout(function () { cnt.classList.remove('is-pulse'); }, 480); }
      var fc = document.querySelector('[data-floating-count]'); if (fc) fc.textContent = n;
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cb-qa-id]'); if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation(); b.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.cbQaId, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (d) {
        b.classList.remove('is-loading'); b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1400);
        showToast(b.dataset.img, b.dataset.name, b.dataset.size); refreshCount();
        try { document.dispatchEvent(new CustomEvent('ld:cart:added', { detail: (d.items && d.items[0]) || d })); } catch (_) {}
      })
      .catch(function () { b.classList.remove('is-loading'); location.href = '/products/' + (b.closest('.cb-card').dataset.handle || ''); });
  }, true);
  // size panel position + entrance stagger
  var io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function prep(root) {
    (root || document).querySelectorAll('.cb-card:not([data-cb-i])').forEach(function (c) {
      c.dataset.cbI = '1';
      var m = c.querySelector('.cb-card__media');
      if (c.querySelector('[data-cb-qa]')) { c.classList.add('has-qa'); if (m) c.style.setProperty('--cb-media-h', (m.offsetTop + m.offsetHeight) + 'px'); }
      if (io && c.getBoundingClientRect().top > innerHeight) {
        var sib = c.parentElement ? Array.prototype.indexOf.call(c.parentElement.children, c) : 0;
        c.style.setProperty('--d', ((sib % 5) * 0.07) + 's'); c.classList.add('cb-in'); io.observe(c);
      }
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('.cb-card.has-qa').forEach(function (c) { var m = c.querySelector('.cb-card__media'); if (m) c.style.setProperty('--cb-media-h', (m.offsetTop + m.offsetHeight) + 'px'); }); });
  // PDP zoom (each image zooms on its own hover: front and back)
  function zoom() {
    if (!fine) return;
    document.querySelectorAll('.ld-gallery2__slide:not([data-cb-z]), .ld-gallery2__main:not(:has(.ld-gallery2__slide)):not([data-cb-z])').forEach(function (sl) {
      sl.dataset.cbZ = '1'; sl.classList.add('cb-zoomable');
      var img = sl.querySelector('img'); if (!img) return; img.classList.add('cb-zoom');
      sl.addEventListener('mousemove', function (e) {
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        sl.classList.add('is-zoom');
      });
      sl.addEventListener('mouseleave', function () { sl.classList.remove('is-zoom'); });
    });
  }
  function boot() { prep(); zoom(); setTimeout(function () { document.querySelectorAll('.cb-card.cb-in:not(.is-in)').forEach(function (c) { if (c.getBoundingClientRect().top < innerHeight) c.classList.add('is-in'); }); }, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  var mo = null; new MutationObserver(function () { if (mo) return; mo = setTimeout(function () { mo = null; prep(); zoom(); }, 350); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Front/back slider + clubs by league ===== */
(function () {
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('[data-cb-fb]'); if (f) f.style.setProperty('--p', e.target.value + '%');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cb-clubtabs] button'); if (!b) return;
    var wrap = b.closest('.cb-wrap'), lg = b.dataset.league, i = 0;
    wrap.querySelectorAll('[data-cb-clubtabs] button').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
    wrap.querySelectorAll('.cb-club').forEach(function (c) {
      var show = lg === 'all' || c.dataset.league === lg;
      c.classList.toggle('is-hidden', !show); c.classList.remove('is-pop');
      if (show) { void c.offsetWidth; c.style.setProperty('--d', (i++ * 0.05) + 's'); c.classList.add('is-pop'); }
    });
  });
})();
